export const reports = {
  reports: 'Informes',
  paymentHistoryError:
    'La consulta del historial de operaciones está limitada a 24 horas. Por favor, especifique un período correcto.',
};
